import type { ReactNode } from 'react'

/**
 * What a screen says when there is nothing on it yet.
 *
 * Always with a way forward. An empty screen in this app usually means the
 * family has been busy living rather than logging, so nothing here counts
 * anything, regrets anything, or implies a streak was broken.
 */
export function EmptyState({
  title,
  body,
  action,
  icon,
}: {
  title: string
  body: string
  action?: { label: string; onClick: () => void }
  icon?: ReactNode
}) {
  return (
    <div className="empty section">
      {icon && (
        <div className="empty-icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <p className="empty-title">{title}</p>
      <p className="empty-body">{body}</p>
      {action && (
        <div className="empty-action">
          <button className="btn btn-primary" onClick={action.onClick}>
            {action.label}
          </button>
        </div>
      )}
    </div>
  )
}
